class CustomForm extends HTMLElement {
    constructor() {
        super();
        this.activateDefaultTab();
        this.setupEventListeners();
    }

    activateDefaultTab() {
        const defaultTab = this.querySelector('.block__heading .heading__one');
        const defaultForm = this.querySelector('.form__content');

        defaultTab?.classList.add('active__tab');
        defaultForm?.classList.add('active__form');
    }

    setupEventListeners() {
        const tabs = this.querySelectorAll('.block__item');
        if (tabs.length <= 1) return;

        tabs.forEach(tab => {
            tab.addEventListener('click', this.handleTabClick.bind(this));
        });
    }

    handleTabClick(event) {
        const clickedTab = event.currentTarget;
        if (!clickedTab) return;

        this.updateActiveTab(clickedTab);
        this.toggleContent(clickedTab);
    }

    updateActiveTab(clickedTab) {
        this.querySelectorAll('.block__item').forEach(tab => {
            tab.classList.remove('active__tab');
        });
        clickedTab.classList.add('active__tab');
    }

    toggleContent(clickedTab) {
        const formContent = this.querySelector('.form__content');
        const calendlyWrapper = this.querySelector('.calendly__wrapper');

        const isFormTab = clickedTab.classList.contains('heading__one');

        formContent?.classList.toggle('active__form', isFormTab);
        calendlyWrapper?.classList.toggle('active__calendly', !isFormTab);
    }
}

customElements.define('custom-form', CustomForm);